var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footerhold"},[_c('div',{staticClass:"footer"},[_c('div',{staticClass:"text-center col"},[_c('span',{staticClass:"light_text"},[_vm._v(_vm._s(_vm.footertxt)+"\r\n      ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }